const ActionNames: {
  LOADING_PROCTOR_CONFIG: 'LOADING_PROCTOR_CONFIG';
  LOADED_PROCTOR_CONFIG: 'LOADED_PROCTOR_CONFIG';
} = {
  LOADING_PROCTOR_CONFIG: 'LOADING_PROCTOR_CONFIG',
  LOADED_PROCTOR_CONFIG: 'LOADED_PROCTOR_CONFIG',
};

export { ActionNames };
